import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { ValidateZipCode, ValidateZipCodeResponse } from '@models/swagger';
import { ValidateZipCodeParams } from './service';

export enum ValidateZipCodeActions {
  Failure = '[Application Utilities ValidateZipCode] Failure',
  Request = '[Application Utilities ValidateZipCode] Request',
  Success = '[Application Utilities ValidateZipCode] Success',
}

export const ValidateZipCodeFailure = createAction(
  ValidateZipCodeActions.Failure,
  props<{ error: HttpErrorResponse }>()
);

export const ValidateZipCodeRequest = createAction(
  ValidateZipCodeActions.Request,
  props<{ body: ValidateZipCode; parameters?: ValidateZipCodeParams }>()
);

export const ValidateZipCodeSuccess = createAction(
  ValidateZipCodeActions.Success,
  props<{ data: ValidateZipCodeResponse }>()
);
